export const CODE_VERIFICATION_TYPES = {
  NEW_LOGIN_DEVICE: 'NEW_LOGIN_DEVICE',
  REVALIDATE_SESSION: 'REVALIDATE_SESSION',
}
